<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="partnumber"><i><b>Part I</b></i></h2>
<h2 class="part">Individual Composers</h2>
<p class="part1"><i>Their Solo Piano Works in Various Editions and Facsimile Reproductions</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?1a927da2